import Link from 'next/link';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

import { useAccessibilitySettings } from '@/hooks/useAccessibilitySettings';

type CallToActionProps = {
  title: string;
  buttonHref: string;
  buttonLabel: React.ReactNode;
  className?: string;
};

function CallToAction({
  title,
  buttonHref,
  buttonLabel,
  className,
}: CallToActionProps) {
  const { useHighContrast } = useAccessibilitySettings();

  return (
    <section
      className={twMerge(
        'pt-12 pb-12 lg:pt-20 lg:pb-20',
        useHighContrast ? 'bg-contrast-yellow text-black' : 'bg-[#fbfbee]',
        className
      )}
    >
      <div className="container flex flex-col items-center">
        <h2 className={twMerge('text-2xl lg:text-3xl text-center mb-10')}>
          {title}
        </h2>

        <Link prefetch={false} href={buttonHref}>
          <a
            className={twMerge(
              'btn btn-xl',
              useHighContrast ? 'btn-contrast-yellow' : 'btn-primary'
            )}
          >
            {buttonLabel}
          </a>
        </Link>
      </div>
    </section>
  );
}

export default CallToAction;
